import { Class, ClassPropertyValues, IClass } from "../System/Class";
import { NAMESPACE } from "./_Namespace";

export type AttributePropertyValues =
    ClassPropertyValues
    & {
    };

export type AttributeProperties = {
    [name in keyof AttributePropertyValues]?: AttributePropertyValues[name];
};

export interface IAttribute extends IClass, AttributeProperties
{
}

export abstract class Attribute extends Class implements IAttribute
{
    public static override classNamespace = NAMESPACE + "Attribute";
    public static override className = "Attribute";

    constructor(propertyValues?: Partial<AttributePropertyValues>)
    {
        super();
    }
}